// @ts-nocheck
import { Component, Input } from '@angular/core';

@Component({
  selector: 'lbca-message-field',
  templateUrl: './message-field.component.html',
})
export class MessageFieldComponent {
  option: any[] = [];
  fieldProps;
  labelValue;
  colorValue;
  entityValue;
  colors = ['primary', 'success', 'danger', 'warning', 'info'];
  public variant: 'outlined' | 'filled' = 'filled';

  @Input() set label(value: string) {
    this.labelValue = value;
  }
  @Input() set color(value: string) {
    if (this.colors.includes(value)) {
      this.colorValue = value;
    } else {
      this.colorValue = 'primary';
    }
  }

  @Input('variant') set setVariant(variant: 'outlined' | 'filled') {
    this.variant = variant;
  }
}
